import { auth } from '@rhitics/core'
import Vue, { VNode } from 'vue'
import MastHead from '@rhitics/vue/components/MastHead.vue'
import { AxiosError } from 'axios'

export default Vue.extend({
  name: 'ResetPassword',

  components: {
    MastHead
  },

  data() {
    return {
      form: {
        email: '',
        code: '',
        password: '',
        loading: false
      },

      error: '',

      showPassword: false
    }
  },

  created() {
    const code = this.$route.query.code as string | undefined
    const email = this.$route.query.email as string | undefined

    this.form.code = code || ''
    this.form.email = email || ''
  },

  methods: {
    async submit(event: Event) {
      if (this.form.loading) return false
      try {
        this.form.loading = true
        const { loading, ...data } = this.form
        await auth.resetPassword(data)
        this.$router.push({ name: 'login' })
      } catch (e) {
          let message: string = 'Oops! looks something went wrong, please contact IT team.'
          if ((e as AxiosError).response?.status === 422) {
            message = 'Password format incorrect.'
          }
          if ((e as AxiosError).response?.status === 404) {
            message = 'Reset password confirm code expired, please apply new reset password request again.'
          }
          this.error = message
          window.setTimeout(() => (this.error = ''), 5000)
      } finally {
        this.form.loading = false
      }
      event.preventDefault()
    }
  },

  render(): VNode {
    const formBody = (
      <v-form class="mt-5" on={{ submit: this.submit }}>
        <div class="headline mb-2">Reset Password</div>
        <v-text-field disabled label="Email" type="email" v-model={this.form.email} />
        <v-text-field disabled label="Confirm Code" type="text" v-model={this.form.code} />
        <v-text-field
          required
          label="Password"
          type={this.showPassword ? 'text' : 'password'}
          append-icon={this.showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
          v-model={this.form.password}
          on={{
            'click:append': () => (this.showPassword = !this.showPassword)
          }}
        />
        <v-row>
          <v-spacer />
          <v-btn
            small
            disabled={this.form.loading}
            loading={this.form.loading}
            color="primary"
            type="submit"
            on={{ click: this.submit }}
          >
            Submit
          </v-btn>
        </v-row>
      </v-form>
    )

    const errorAlert = this.error ? (
      <v-alert dense outlined type="error">
        {this.error}
      </v-alert>
    ) : null

    return (
      <v-app>
        <mast-head />
        <v-content>
          <v-container grid-list-md>
            <v-row>
              <v-col xs="12" offset-md="3" md="6">
                {formBody}
                {errorAlert}
              </v-col>
            </v-row>
          </v-container>
          <router-view />
        </v-content>
      </v-app>
    )
  }
})
